<template>
    <div class="fixed-scroller">
        <div class="v-alert w-600">
            <header><p>Offer - Campaigns & Customers</p><div class="x" @click="$emit('emit',{ action: 'exit' })"></div></header>
            <div class="cc-box">
                <div class="cc-customers">
                    <p>Members</p>
                    <div class="cc-container">
                        <p v-for="customer in customers">{{ customer.name }}</p>
                    </div>
                </div>
                <div class="cc-campaigns">
                    <p>Campaigns</p>
                    <div class="cc-container">
                        <p v-for="campaign in campaigns">{{ campaign.title }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import WebSoc from '../utils/WebSoc.js'

export default {
    props: ['item'],
    computed: {
        client_id () { return this.$store.state.client_id }
    },
    data () {
        return {
            customers: [],
            campaigns: []
        }
    },
    mounted () {
        WebSoc.SEND('search',{ DB: this.client_id+'-customers', find: { $or: this.item.customers }, project: { name: 1 }},customers => {
            this.customers = this.item.customers.reduce((p,c) => {
                var exits = customers.find(customer => customer._id == c._id);
                c.name = exits ? exits.name : 'no name';
                p.push(c);
                return p;
            },[])
        });
        console.log('this.campaigns',this.campaigns);
        WebSoc.SEND('search',{ DB: 'surveys', find: { $or: this.item.campaigns }, project: { title: 1 } },campaigns => {
            console.log('campaigns',campaigns);
            this.campaigns = this.item.campaigns.reduce((p,c) => {
                var exits = campaigns.find(campaign => campaign._id == c._id);
                c.title = exits ? exits.title : 'no name';
                p.push(c);
                return p;
            },[]);         
        })
    }
}

</script>

<style lang="scss">
.cc-box {
    display: grid;
    grid-template-columns: 1fr 1fr;
    float: left;
    width: 100%;
    height: 220px;
    > div {
        height: calc(100% - 40px);
        > p {
            margin: 5px;
        }
    }
    .cc-container {
        border: 1px solid #c0c0c0;
        margin: 5px;
        width: calc(100% - 15px);
        height: calc(100% - 40px);
        position: relative;
        overflow-y: scroll;
        > p {
            padding: 3px;
            &:nth-child(even) { background-color: rgba(100,100,100,0.3); }
        }
    }
}    
</style>